var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClapHands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M43.1759 4.9668L40.5359 7.6068",
    stroke: "#4E72B6",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M20.9802 4.9668L23.4247 7.41124",
    stroke: "#4E72B6",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M32.0782 3.11133V6.558",
    stroke: "#4E72B6",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M36.3118 55.7741C41.4671 56.395 46.8424 54.7426 50.7975 50.785V50.785C54.9384 46.6441 56.7351 40.7066 55.5887 34.9646L52.5527 19.7894C52.1982 18.0148 50.6387 16.7363 48.8273 16.7363V16.7363C46.73 16.7363 45.0287 18.4377 45.0287 20.535V24.1601",
    stroke: "#4E72B6",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M38.2377 20.3172L33.7937 15.8732C32.3612 14.4407 30.039 14.4407 28.609 15.8732V15.8732C27.1766 17.3056 27.1766 19.6278 28.609 21.0578",
    stroke: "#4E72B6",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M17.2451 20.0695C15.8127 18.6371 15.8127 16.3149 17.2451 14.8849V14.8849C18.6776 13.4524 20.9998 13.4524 22.4298 14.8849L31.9362 24.3913L37.1209 29.576V23.0029C37.1209 20.9055 38.8222 19.2042 40.9196 19.2042V19.2042C42.7309 19.2042 44.2905 20.4827 44.6449 22.2573L47.3803 35.9389C48.5291 41.6809 46.7325 47.6184 42.5891 51.7593V51.7593C35.7496 58.5989 24.6591 58.5989 17.8196 51.7593L11.1951 45.1324L5.14513 39.0824C3.71269 37.65 3.71269 35.3278 5.14513 33.8978V33.8978C6.57758 32.4653 8.8998 32.4653 10.3298 33.8978",
    stroke: "#4E72B6",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M18.1105 41.6734L6.87585 30.4387C5.4434 29.0062 5.4434 26.684 6.87585 25.254V25.254C8.30829 23.8216 10.6305 23.8216 12.0605 25.254",
    stroke: "#4E72B6",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M23.2952 36.4872L8.60412 21.7961C7.17167 20.3637 7.17167 18.0414 8.60412 16.6114V16.6114C10.0366 15.179 12.3588 15.179 13.7888 16.6114L28.4799 31.3026",
    stroke: "#4E72B6",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClapHands);
export default __webpack_public_path__ + "static/media/clap-hands.848850e8d5282532aeb77dab86a2565a.svg";
export { ForwardRef as ReactComponent };